import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section background="cream" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <div className="mb-6 flex justify-center" data-id="element-61">
          <ShieldCheck className="w-16 h-16 text-[#D4AF37]" data-id="element-62" />
        </div>
        <h2 className="text-3xl font-bold mb-6" data-id="element-63">La promesa real</h2>
        <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-64">
          No te prometo que mañana serás millonaria. Te prometo algo mucho más
          poderoso:
        </p>
        <div className="bg-white p-8 rounded-xl shadow-sm border border-[#D4AF37]/20 mb-8" data-id="element-65">
          <p className="text-2xl font-serif text-gray-900 italic" data-id="element-66">
            "Pensar, decidir y actuar como una mujer que sabe crear abundancia."
          </p>
        </div>
        <p className="text-lg text-gray-600" data-id="element-67">
          Y cuando eso ocurre… el dinero deja de ser una lucha y se convierte en
          una consecuencia.
        </p>
      </div>
    </Section>;
}